package com.example.socialmediaapp

import androidx.compose.ui.ExperimentalComposeUiApi
import androidx.compose.ui.window.ComposeViewport

@OptIn(ExperimentalComposeUiApi::class)
fun main() {
    console.log("[MAIN] main() called — Compose viewport starting")
    ComposeViewport {
        console.log("[MAIN] ComposeViewport lambda entered — App() launching")
        App()
        console.log("[MAIN] App() compose call returned")
    }
    console.log("[MAIN] ComposeViewport registered")
}